/** Policy tabs: switch + anchor + Theme Editor reload (no equalized min-height). **/
/** Custom popup: ported from ecoflow-tech theme.js (Product init) — Canada theme.js lacked this. **/
(function () {
  function bindPolicyBannerAnchors(root) {
    root.querySelectorAll(".policy-banner-anchor").forEach((el) => {
      if (el.dataset.policyAnchorBound) return;
      el.dataset.policyAnchorBound = "1";
      el.addEventListener("click", (e) => {
        const href = el.getAttribute("href") || "";
        if (!href.startsWith("#") || href === "#") return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function centerTitleInHeader(title) {
    const header = title.closest(".policy-tabs-header");
    if (!header) return;
    const targetScrollLeft =
      title.offsetLeft + title.offsetWidth / 2 - header.clientWidth / 2;
    const maxScrollLeft = header.scrollWidth - header.clientWidth;
    header.scrollTo({
      left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
      behavior: "smooth",
    });
  }

  function initPolicyTabs(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll
      ? scope.querySelectorAll(".policy-tabs-section")
      : [];
    const list =
      scope.classList && scope.classList.contains("policy-tabs-section")
        ? [scope]
        : Array.from(sections);

    list.forEach((section) => {
      if (section.dataset.policyTabsReady === "1") return;
      section.dataset.policyTabsReady = "1";

      const body = section.querySelector(".policy-tabs-body");
      if (body) {
        // Clear legacy equalized height from prior builds
        body.style.minHeight = "";
      }

      section.querySelectorAll(".policy-tab-title").forEach((title) => {
        title.addEventListener("click", () => {
          title.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
          centerTitleInHeader(title);
          const targetId = title.getAttribute("data-tab-target");
          const container = title.closest(".policy-tabs-section");
          if (!targetId || !container) return;

          container.querySelectorAll(".policy-tab-title").forEach((t) => {
            t.classList.remove("active");
          });
          title.classList.add("active");

          container.querySelectorAll(".policy-tab-content").forEach((c) => {
            c.classList.remove("active");
          });
          const targetContent = container.querySelector("#" + CSS.escape(targetId));
          if (targetContent) targetContent.classList.add("active");
        });
      });

      bindPolicyBannerAnchors(section);
    });
  }

  function initCustomPopup(root) {
    const scope = root || document;
    const section =
      (scope.closest && scope.closest(".section-product-template")) ||
      (scope.classList && scope.classList.contains("section-product-template")
        ? scope
        : null) ||
      document.querySelector(".section-product-template");
    if (!section) return;

    const customPopup = section.querySelector(".custom-popup");
    if (!customPopup || customPopup.dataset.customPopupReady === "1") return;
    customPopup.dataset.customPopupReady = "1";

    const customHeading = customPopup.querySelector(".custom-popup__content-heading");
    const customHtml = customPopup.querySelector(".custom-popup__content-html");
    const customClose = customPopup.querySelector(".custom-popup__close");
    if (!customHeading || !customHtml || !customClose) return;

    customClose.addEventListener("click", () => {
      customPopup.classList.remove("show");
    });

    section.querySelectorAll(".custom-popup-triger").forEach((item) => {
      if (item.dataset.customPopupBound === "1") return;
      item.dataset.customPopupBound = "1";
      item.addEventListener("click", () => {
        const html = item.querySelector(".custom-popup-triger-html");
        if (!html) return;
        const content = html.cloneNode(true);
        customHeading.innerHTML = item.dataset.title || "";
        customHtml.innerHTML = content.innerHTML;
        customPopup.classList.add("show");

        const popupSwiperElements = customHtml.querySelectorAll(".swiper");
        if (popupSwiperElements.length > 0 && typeof Swiper !== "undefined") {
          popupSwiperElements.forEach((elem) => {
            new Swiper(elem, {
              slidesPerView: 1,
              pagination: {
                el: customHtml.querySelector(".swiper-pagination"),
                clickable: true,
              },
              navigation: {
                nextEl: customHtml.querySelector(".swiper-button-next"),
                prevEl: customHtml.querySelector(".swiper-button-prev"),
              },
            });
          });
        }
      });
    });
  }

  window.initPolicyTabs = initPolicyTabs;
  window.initCustomPopup = initCustomPopup;

  function initAll(root) {
    initPolicyTabs(root || document);
    initCustomPopup(root || document);
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));
  document.addEventListener("shopify:section:load", (e) => {
    if (e && e.target) {
      e.target.querySelectorAll(".policy-tabs-section").forEach((section) => {
        delete section.dataset.policyTabsReady;
      });
      const popup = e.target.querySelector
        ? e.target.querySelector(".custom-popup")
        : null;
      if (popup) delete popup.dataset.customPopupReady;
      e.target.querySelectorAll(".custom-popup-triger").forEach((item) => {
        delete item.dataset.customPopupBound;
      });
      initAll(e.target);
    }
  });
})();
